import React from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";
import type { CommonColors } from "../../../types/colors";

export interface AttributeBadgeProps {
  className?: string;
  color?: CommonColors | "default";
  label: string;
  attribute?: string | number;
}

export const COLORS: Record<CommonColors | "default", string> = {
  default: "bg-neutral-50 text-neutral-600",
  primary: "bg-neutral-100 text-primary-900",
  info: "bg-info-500 text-neutral-900",
  error: "bg-error-200 text-error-800",
  warning: "bg-warning-200 text-warning-800",
  success: "bg-success-200 text-neutral-800",
};

export const SupAttributeBadge = ({ attribute, className, label, color = "default" }: AttributeBadgeProps) =>
  label && label.length > 0 ? (
    <span className={twMerge("inline-flex box-border border-0.5 border-current h-5", COLORS[color], className)}>
      <Text
        variant="subtitle1"
        as="span"
        className="inline-flex min-w-[1.25rem] px-0.5 text-current border-r-0.5 border-current items-center justify-center place-items-center text-neutral-900"
      >
        {attribute ?? label[0]}
      </Text>
      <Text variant="subtitle2" as="span" className="inline-flex text-current items-center px-1.5 text-neutral-900">
        {label}
      </Text>
    </span>
  ) : null;
